import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageTrackingContext = /*#__PURE__*/createContext({
  track: () => {}
});
export const useUsageTracking = () => {
  const context = useContext(UsageTrackingContext);
  if (context === undefined) {
    throw new Error('useUsageTracking must be used within a UsageTrackingContext Provider');
  }
  return context;
};
export const UsageTrackingProvider = ({
  appKey,
  children,
  usageTracker
}) => {
  const track = e => usageTracker.track(appKey, e);
  return /*#__PURE__*/_jsx(UsageTrackingContext.Provider, {
    value: {
      track
    },
    children: children
  });
};